import { useNavigate, Outlet } from "react-router-dom";

import ErrorBoundary from "@/ui/organisms/ErrorBoundary";
import LayoutFullScreen from "@/ui/layouts/LayoutFullScreen";

import {
    ViewCreateChartOfAccounts,
    ViewDatabaseGuard,
    ViewTopBar,
    ViewNewExperienceSection,
    ViewNavigationSidebar,
} from "@/ui/compositionRootUI";

import { routerPaths } from "@/ui/router/routerPaths";
import GridLoader from "@/ui/molecules/GridLoader";

const VIEW_EDIT_CHART_OF_ACCOUNTS_ACTION_BAR_HEIGHT = 100;

const PageCreateChartOfAccounts = () => {
    const navigate = useNavigate();

    const navigateToDashboard = () => {
        navigate(routerPaths.chartsOfAccounts.dashboard("list"));
    };

    return (
        <LayoutFullScreen
            TopBarProps={{
                sx: {
                    backgroundColor: "var(--proda-white-110)",
                },
                onLogoClick: () => navigate(routerPaths.main.default()),
            }}
            MainContentProps={{
                sx: {
                    backgroundColor: "var(--proda-white)",
                    borderTop: "1px solid var(--primary-color)",
                },
            }}
            contentTopBar={<ViewTopBar />}
            contentTopBarBanner={<ViewNewExperienceSection />}
            contentSidebar={<ViewNavigationSidebar />}
        >
            <ErrorBoundary>
                <ViewDatabaseGuard
                    loader={
                        <GridLoader
                            sx={{
                                paddingTop: `${VIEW_EDIT_CHART_OF_ACCOUNTS_ACTION_BAR_HEIGHT}px`,
                            }}
                        />
                    }
                >
                    <ViewCreateChartOfAccounts
                        navigateToDashboard={navigateToDashboard}
                    />
                </ViewDatabaseGuard>
                <Outlet />
            </ErrorBoundary>
        </LayoutFullScreen>
    );
};

export default PageCreateChartOfAccounts;
